const addBtns = document.querySelectorAll(".js-product-card-add");
if (addBtns.length) {
  addBtns.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      if (button.hasAttribute("data-limited-product-add")) {
        const id = button.getAttribute("data-limited-product-add");
        const limit = button.getAttribute("data-quantity-limit");
        const isWholesaleSample = button.getAttribute("data-wholesale-sample");
        let quantity = 1;

        let props = {};
        if (isWholesaleSample == "true") {
          props.Wholesale_Sample = "True";
        }

        if (button.getAttribute("data-pack-size") != null) {
          const packSize = parseFloat(button.getAttribute("data-pack-size"));
          quantity = packSize;
          props._qtymultiple = quantity;
        }

        if (limit != null) {
          props._qtylimit = limit;
        }

        addToCart(id, quantity, props);
      } else if (button.hasAttribute("data-cart-add-exclude")) {
        const id = button.getAttribute("data-cart-add-exclude");
        const quantity = 1;
        let props = {};
        props._exclude = "true";
        addToCart(id, quantity, props);
      } else {
        const form = button.closest("form");
        form.submit();
      }
    });
  });
}

function addToCart(id, quantity, props) {
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [{ id: id, quantity: quantity, properties: props }],
    }),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch(function (error) {
      console.error("Error:", error);
    });
}

const quantities = document.querySelectorAll(".js-quantity-wrapper");
if (quantities.length) {
  quantities.forEach((wrapper) => {
    const form = wrapper.closest("form");
    const input = wrapper.querySelector(".input-quantity");
    const minus = wrapper.querySelector(".js-quantity-decrease");
    const plus = wrapper.querySelector(".js-quantity-increase");
    const packSize = input.getAttribute("data-pack-size")
      ? parseFloat(input.getAttribute("data-pack-size"))
      : null;
    const min = input.getAttribute("min")
      ? parseFloat(input.getAttribute("min"))
      : 1;
    const maxQuantity = input.getAttribute("max")
      ? parseFloat(input.getAttribute("max"))
      : null;

    if (min) {
      productQuantity = min;
      input.value = productQuantity;
    }

    if (packSize) {
      let quant = parseFloat(input.value);
      minus.addEventListener("click", (e) => {
        e.preventDefault();
        if (quant - packSize >= min) {
          quant = quant - packSize;
          input.value = quant;
        }

        updateButtons(quant, min, maxQuantity, minus, plus);
        updateInputs(form, quant);
      });

      plus.addEventListener("click", (e) => {
        e.preventDefault();
        if (maxQuantity) {
          if (quant + packSize <= maxQuantity) {
            quant = quant + packSize;
            input.value = quant;
          }
        } else {
          quant = quant + packSize;
          input.value = quant;
        }

        updateButtons(quant, min, maxQuantity, minus, plus);
        updateInputs(form, quant);
      });
    }
  });

  function updateInputs(form, quant) {
    const formInputs = form.querySelectorAll("input#quantity");
    formInputs.forEach((el) => {
      el.value = quant;
    });
  }

  function updateButtons(quantity, min, max, minus, plus) {
    if (minus) {
      const minText = minus.querySelector("span");
      if (quantity <= min) {
        minText.classList.add("text-grey-200");
        minText.classList.remove("text-black");
      } else {
        minText.classList.remove("text-grey-200");
        minText.classList.add("text-black");
      }
    }

    if (plus) {
      const maxText = plus.querySelector("span");
      if (quantity >= max) {
        maxText.classList.add("text-grey-200");
        maxText.classList.remove("text-black");
      } else {
        maxText.classList.remove("text-grey-200");
        maxText.classList.add("text-black");
      }
    }
  }
}
